import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Relative = styled.div`
  position: relative;
`;
const Blur = styled.div`
  filter: blur(32px);
  position: absolute;
  inset: 0;
`;

export const RewardBaseIcon = ({ children }: PropsWithChildren) => {
  return (
    <Relative>
      {children}
      <Blur>{children}</Blur>
    </Relative>
  );
};
